function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { createContext, useContext } from '../../_snowpack/pkg/react.js';
import { responsive } from '../css/index.js';
export const MediaGateContext = /*#__PURE__*/createContext();
export const useMedia = () => useContext(MediaGateContext); // const isMobile = window.matchMedia(responsive.xs);

export default class MediaProvider extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      media: []
    });

    _defineProperty(this, "matches", {});

    _defineProperty(this, "setupMatches", () => {
      Object.keys(responsive).forEach(this.setupMedia);
    });

    _defineProperty(this, "setupMedia", key => {
      this.matches[key] = window.matchMedia(responsive[key].replace('@media ', ''));
      this.matches[key].addListener(e => {
        this.setState(s => {
          if (e.matches) {
            if (!s.media.includes(key)) {
              return {
                media: [...s.media, key]
              };
            }
          } else {
            const m = [...s.media];
            m.splice(m.indexOf(key), 1);
            return {
              media: m
            };
          }
        });
      });
    });

    _defineProperty(this, "getCurrentMatches", () => {
      const media = [];
      Object.keys(this.matches).forEach(matchKey => {
        if (this.matches[matchKey].matches) {
          media.push(matchKey);
        }
      });
      this.setState({
        media
      });
    });
  }

  componentDidMount() {
    this.setupMatches();
    this.getCurrentMatches();
  }

  render() {
    const {
      children
    } = this.props;
    const {
      media
    } = this.state;

    if (media.length === 0) {
      return null;
    }

    return /*#__PURE__*/React.createElement(MediaGateContext.Provider, {
      value: media
    }, children);
  }

}